import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class DashboardApi {
  getOverallCounts = async () => {
    try {
      const response = await api.get("/dashboard/overall-counts");
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Dashboard Counts. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getExpoStatistics = async (params) => {
    try {
      const response = await api.get("/dashboard/expo-statistics", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Expo Statistics. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getDetailedAnalysis = async (expoId) => {
    try {
      const response = await api.get(`/dashboard/detailed-analysis`, { params: { expoId } });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Detailed Analysis. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getExpoList = async () => {
    try {
      const response = await api.get("/expo/list"); // Assuming /expo/list based on common patterns
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      // Don't show notification for expo list to avoid cluttering if it's just for a dropdown
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };
}

const dashboardApi = new DashboardApi();
export default dashboardApi;

export const { getOverallCounts, getExpoStatistics, getDetailedAnalysis, getExpoList } = dashboardApi;
